import { render, staticRenderFns } from "./product-image.vue?vue&type=template&id=1934ca5c&"
import script from "./product-image.vue?vue&type=script&lang=js&"
export * from "./product-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports